import { FootballGoalImage } from '@/common/assets';
import { ShotIndicator } from './ShotIndicator';
import type { ShotsChartProps } from './ShotsChart.types';

export default function ShotsChart(props: ShotsChartProps) {
  const {
    className = '',
    homeOffTarget = 0,
    homeOnTarget = 0,
    awayOffTarget = 0,
    awayOnTarget = 0,
  } = props;

  return (
    <div className={`relative flex justify-center ${className}`}>
      <div className="h-[70px] overflow-hidden">
        <FootballGoalImage />
      </div>
      <div className="absolute max-w-[324px] w-full h-full flex items-start justify-between">
        <ShotIndicator value={homeOffTarget} />
        <ShotIndicator className="self-end" value={homeOnTarget} isOnTarget />
        <ShotIndicator className="self-end" value={awayOnTarget} isAway isOnTarget />
        <ShotIndicator value={awayOffTarget} isAway />
      </div>
    </div>
  );
}
